import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrDangerLadderComponent } from './pr-danger-ladder.component';

@NgModule({
  declarations: [PrDangerLadderComponent],
  imports: [CommonModule],
  exports: [PrDangerLadderComponent],
})
export class PrDangerLadderModule {}
